import PropTypes from 'prop-types';

import imagePropTypes from '@glass/shared/components/Content/propTypes/imagePropTypes';

const blogPostPropTypes = PropTypes.shape({
  author: PropTypes.shape({
    color: PropTypes.string,
    image: imagePropTypes,
    name: PropTypes.string,
    slug: PropTypes.string,
  }),
  body: PropTypes.string,
  color: PropTypes.string,
  description: PropTypes.string,
  heroImage: imagePropTypes,
  publishedAt: PropTypes.string,
  tagsCollection: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        color: PropTypes.string,
        name: PropTypes.string,
        slug: PropTypes.string,
      }),
    ),
  }),
  title: PropTypes.string,
  updatedAt: PropTypes.string,
});

export default blogPostPropTypes;
